import { v4 as uuidv4 } from 'uuid';
import { MarketingEventsDepartmentsGrid } from './MarketingEventsDepartmentsGrid';
import { MarketingEventsDepartmentsGridPluginSettings } from './MarketingEventsDepartmentsGridPluginSettings';
import i18n from '../../../../i18n';

export const MarketingEventsDepartmentsTab = (): ITab => {
    const t = (value: string) => i18n.t("sidePanel.directory.submenu." + value);
    return {
        id: uuidv4(),
        title: t("marketingEventsDepartments"),
        view: {
            content: MarketingEventsDepartmentsGridPluginSettings
                ? <MarketingEventsDepartmentsGrid gridId={uuidv4()} plugin={MarketingEventsDepartmentsGridPluginSettings} />
                : <p> Справочник не настроен</p>
        }
    }
}
